@if (listItem) {
    <ui-list-view-container>
        <ui-detail-image
            image
            [imagePath]="listItem.imagePath"
        />
        <ui-detail-section [fullWidth]="true">
            <ui-detail-tags
                [ariaLabel]="'Kategorien'"
                [tags]="listItem.categories"
            />
            <ui-detail-title [title]="listItem.title"/>
            @if (listItem.description) {
                <ui-detail-description
                    [htmlDescription]="listItem.description"
                />
            }
            <p-divider/>
        </ui-detail-section>
        <ui-detail-tags
            [ariaLabel]="'Projektträger'"
            [tags]="listItem.sponsors"
        />
        <ui-detail-section
            title="Beteiligte"
            [isList]="true"
        >
            @for (department of listItem.departments; track $index) {
                <ui-detail-weblink
                    [linkLabel]="department.label"
                    [link]="department.weblink"
                />
            }
        </ui-detail-section>
        @if (listItem.weblink) {
            <ui-detail-weblink
                [ariaLabel]="'Mehr zu ' + listItem.title"
                [linkLabel]="'Mehr dazu'"
                [link]="listItem.weblink"
                [outlined]="true"
            />
        }
    </ui-list-view-container>
}
